import React, { Component, PropTypes } from 'react';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import BFWFeaturedOfferCard from './BFWFeaturedOfferCard';

export default class BFWFeaturedOffersSection extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.bfwOffersFeatured.isLoaded) {
      return <span />
    }

    let bfwOffersFeatured = this.props.bfwOffersFeatured;

    let featuredOffers = bfwOffersFeatured.map((offerItem, idx) => {

      if (idx <= 5) {
        return <div className="featuredOfferCard-outerWrapper">
          <BFWFeaturedOfferCard key={offerItem.id}
            offerId={offerItem.id}
            orgLogoUrl={offerItem.org_logo_url}
            organizationName={offerItem.organization_name}
            website={offerItem.website}
            organizationId={offerItem.organization_id}
            organizationSlug={offerItem.organization_slug}
          />
          </div>;
      }

    });

    return(
      <div>
        <h2 className="page-header">This week's featured businesses</h2>
        <div className="BFWOffers-featuredOffersWrapper">

          {featuredOffers}

        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/bfwOffers/BFWFeaturedOffersSection.jsx